(() => {
  const header = document.querySelector('store-header');
  const headerSection = header?.closest('[id^="shopify-section-"]');
  const entries = window._SM?.newEntries;
  if (!headerSection || !entries) return;

  for (const entry of Object.values(entries)) {
    const settings = entry?.data?.data;
    const selector = settings?.navigator_selector;
    if (typeof selector !== 'string' || !selector.startsWith('#shopify-section-')) continue;
    if (document.querySelector(selector)) continue;

    const currentSelector = selector.replace(/^#[^\s>]+/, `#${CSS.escape(headerSection.id)}`);
    if (document.querySelector(currentSelector)) settings.navigator_selector = currentSelector;
  }
})();